import ReminderOptionType from '../helpers/ReminderOptionType';
import createReminderDisplayString from './createReminderDisplayString';

/**
 * Formats a custom reminder time for the dropdown options and adds it to the appropriate place in the list.
 * @param {number} reminderTimeInMinutes
 * @param {boolean} formatReminderForAllDay
 * @param {ReminderOptionType[]} reminderDropdownOptions
 * @param {typeof createReminderDisplayString} createReminderDisplayStringFunction
 */
export default function addCustomReminderOption(
    reminderTimeInMinutes: number,
    formatReminderForAllDay: boolean,
    reminderDropdownOptions: ReminderOptionType[],
    createReminderDisplayStringFunction: typeof createReminderDisplayString
) {
    // Place it in the correct order.
    let optionToAdd = {
        key: reminderTimeInMinutes,
        text: createReminderDisplayStringFunction(reminderTimeInMinutes, formatReminderForAllDay),
    };
    reminderDropdownOptions.push(optionToAdd);
    reminderDropdownOptions.sort((a, b) => a.key - b.key);
}
